import { FC, useState } from 'react';

import { LegendItem } from './LegendItem';
import { MoreItemsIndicator } from './MoreItemsIndicator';
import { ProcessedLegendItem } from './types';

type HiddenItemsTooltipProps = {
  hiddenItems: ProcessedLegendItem[];
};

export const HiddenItemsTooltip: FC<HiddenItemsTooltipProps> = ({
  hiddenItems
}) => {
  const hiddenCount = hiddenItems.length;
  const [isOpen, setIsOpen] = useState(false);

  const handleMouseEnter = () => {
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    setIsOpen(false);
  };

  return (
    <div
      className="relative cursor-pointer"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <MoreItemsIndicator count={hiddenCount} />
      {isOpen && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 pb-2 z-50 w-max max-w-md">
          <div className="p-3 bg-base-popover border border-border/50 text-foreground rounded-md shadow-sm">
            <div className="flex flex-col gap-1.5 max-h-[300px] overflow-y-auto">
              {hiddenItems.map((processedItem, index) => (
                <LegendItem key={index} itemData={processedItem.itemData} />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
